import { CustomElement } from "../../core/CustomElement";
import Discussion from "../../core/interfaces/Discussion";

export default class DiscussionDetailVm {
  $discussionDetail: CustomElement;
  discussion: KnockoutObservable<Discussion>;
  statusText: KnockoutComputed<string>;
  statusClass: KnockoutComputed<string>;
  countViews: KnockoutComputed<string>;
  countComments: KnockoutComputed<string>;
  lastUser: KnockoutComputed<string>;
  dateLastUser: KnockoutComputed<string>;
  loaded: KnockoutObservable<boolean>;

  constructor($discussionDetail: CustomElement) {
    this.$discussionDetail = $discussionDetail;
    this.discussion = ko.observable(null);
    this.statusText = ko.pureComputed(() => {
      if (this.discussion().attributes) {
        return this.discussion().attributes.status;
      } else {
        return null;
      }
    });
    this.statusClass = ko.pureComputed(() => {
      if (
        [
          "Submitted",
          "More Information Requested",
          "Archived Idea",
          "Archived",
        ].includes(this.statusText())
      ) {
        return "open";
      } else if (
        [
          "Planned",
          "Option for Future Release",
          "Under Oracle Review",
          "Reviewed",
        ].includes(this.statusText())
      ) {
        return "active";
      } else if (["Delivered"].includes(this.statusText())) {
        return "done";
      } else if (
        ["Duplicate", "Current Capability", "Declined"].includes(
          this.statusText()
        )
      ) {
        return "closed";
      } else {
        return "open";
      }
    });
    this.countViews = ko.pureComputed(() => {
      return (
        this.discussion().countViews +
        " " +
        (this.discussion().countViews === 1 ? "view" : "views")
      );
    });
    this.countComments = ko.pureComputed(() => {
      return (
        this.discussion().countComments +
        " " +
        (this.discussion().countComments === 1 ? "comment" : "comments")
      );
    });
    this.lastUser = ko.pureComputed(() => {
      return (
        (this.discussion().insertUser.id !== this.discussion().lastUser.id
          ? "Most recent by "
          : "Started by ") + this.discussion().lastUser.name
      );
    });
    this.dateLastUser = ko.pureComputed(() => {
      const dateLastComment =
        this.discussion().dateLastComment.toLocaleString();
      return dateLastComment;
    });
    this.loaded = ko.observable(false);
  }
}
